define(
({
  "alert": "Varsel",
  "okay": "Ok"
})
);
